import constants from './HomeConstants';

const initialState = {
    apartments: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case constants.GET_HOME_APARTMENTS: {
        return Object.assign({}, state, { apartments: action.payload });
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/containers/Home/HomeReducer.js